import React from 'react';
import { Link } from 'react-router-dom';
import { formatDate, truncateText, DESCRIPTION_TRUNCATE_LEN, promptTemplateEditPath } from '../constants';

function PromptTemplatesTable({ templates }) {
  return (
    <div className="hidden md:block surface-card overflow-hidden">
      <table className="w-full text-sm table-fixed">
        <thead>
          <tr className="border-b border-surface-border bg-slate-50 text-left">
            <th className="px-4 py-3 font-medium text-content-muted w-[22%]">Slug</th>
            <th className="px-4 py-3 font-medium text-content-muted w-[14%]">Categoria</th>
            <th className="px-4 py-3 font-medium text-content-muted w-[34%]">Descrição</th>
            <th className="px-4 py-3 font-medium text-content-muted whitespace-nowrap w-[16%]">
              Atualizado em
            </th>
            <th className="px-4 py-3 font-medium text-content-muted w-[14%]">Ações</th>
          </tr>
        </thead>
        <tbody>
          {templates.map((template) => (
            <tr
              key={template.slug}
              className="border-b border-surface-border last:border-b-0 hover:bg-slate-50/80 transition-colors"
            >
              <td className="px-4 py-3">
                <p className="font-medium text-content-primary font-mono text-xs truncate" title={template.slug}>
                  {template.slug}
                </p>
              </td>
              <td className="px-4 py-3 text-content-secondary whitespace-nowrap">
                {template.category || '—'}
              </td>
              <td className="px-4 py-3 text-content-muted">
                <p
                  className="truncate"
                  title={template.description || undefined}
                >
                  {truncateText(template.description, DESCRIPTION_TRUNCATE_LEN)}
                </p>
              </td>
              <td className="px-4 py-3 text-content-muted whitespace-nowrap">
                {formatDate(template.updated_at)}
              </td>
              <td className="px-4 py-3">
                <Link
                  to={promptTemplateEditPath(template.slug)}
                  className="btn-secondary text-xs px-3 py-2 whitespace-nowrap inline-block"
                >
                  Editar
                </Link>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default PromptTemplatesTable;
